import { onlineUsers } from "../state/online"

export const isOnline = (id = ""): boolean => {
  return onlineUsers.value.includes(id)
}
